import React from 'react';
import PropTypes from 'prop-types';

import { FormControlLabel, Switch as SwitchMUI } from '@mui/material';

import * as Styled from './Switch.styles';

export const Switch = ({ checked, onChange, disabled, label }) => {
  return (
    <Styled.Wrapper>
      <FormControlLabel
        control={
          <SwitchMUI checked={checked} onChange={(event) => onChange(event.target.checked)} disabled={disabled} />
        }
        label={label}
      />
    </Styled.Wrapper>
  );
};

Switch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
};
